import { Route, Routes } from "react-router-dom";
import { RequirePermission } from "@comps/components";
import IndexUserTotalCases from "./IndexUserTotalCases";
import IndexUserNewCases from "./IndexUserNewCases";
import IndexUserModificationCases from "./IndexUserModificationCases";
import IndexUserApprovedCases from "./IndexUserApprovedCases";
import IndexUserRefinementCases from "./IndexUserRefinementCases";
import IndexUserOnHoldCases from "./IndexUserOnHoldCases";
import IndexUserMineCases from "./IndexUserMineCases";
import UserCaseDetail from "./components/UserCaseDetail";
import CreateTreatmentPlan from "./components/CreateTreatmentPlan";
import UpdateTreatmentPlan from "./components/UpdateTreatmentPlan";

/**
 * Each list is behind the same permission key the sidebar filters on and
 * the API now checks — the menu item was hidden from a role that had not
 * been granted the page, but the route itself was open, so typing the
 * path (or following an old link) showed the list anyway.
 *
 * "Your cases" is not one of the granted modules: it is the caller's own
 * work, reached from Total cases, and has no key to hold.
 */
const guarded = (permission, element) => (
  <RequirePermission permission={ permission }>{ element }</RequirePermission>
);

const UserCaseManagementRoutes = () => {
  return (
    <Routes>
      <Route path="/total" element={ guarded("totalcases_index", <IndexUserTotalCases />) } />
      <Route path="/new" element={ guarded("newcases_index", <IndexUserNewCases />) } />
      <Route path="/modifications" element={ guarded("modifications_index", <IndexUserModificationCases />) } />
      <Route path="/approved" element={ guarded("approvedcases_index", <IndexUserApprovedCases />) } />
      <Route path="/refinements" element={ guarded("refinements_index", <IndexUserRefinementCases />) } />
      <Route path="/on-hold" element={ guarded("onholdcases_index", <IndexUserOnHoldCases />) } />
      <Route path="/mine" element={ <IndexUserMineCases /> } />
      <Route path="/details/:id" element={ <UserCaseDetail /> } />
      <Route path="/details/treatment-plan/:id" element={ <CreateTreatmentPlan /> } />
      <Route path="/details/treatment-plan/update/:id" element={ <UpdateTreatmentPlan /> } />
    </Routes>
  )

}

export default UserCaseManagementRoutes;
